import { Drawer, styled } from "@mui/material"
import { IStyledRootProps } from "./types"
import { SIDEBAR_WIDTH_COLLAPSED, SIDEBAR_WIDTH_EXPANDED } from "../../../../consts/sidebarWidth"
import { APP_BAR_HEIGHT } from "../../../../consts/appBarHeight"

const StyledRoot = styled(Drawer, {
    shouldForwardProp: (prop) => prop !== "expanded" && prop !== "isMobile",
})<IStyledRootProps>(({ theme, expanded, isMobile }) => {
    const width = expanded ? SIDEBAR_WIDTH_EXPANDED : SIDEBAR_WIDTH_COLLAPSED
    const transition = theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    })

    return {
        // no mobile o drawer é um overlay e não deve reservar espaço no layout
        width: isMobile ? 0 : width,
        flexShrink: 0,
        whiteSpace: "nowrap",
        transition,
        "& .MuiDrawer-paper": {
            width,
            transition,
            boxSizing: "border-box",
            top: isMobile ? 0 : APP_BAR_HEIGHT,
            height: isMobile ? "100%" : `calc(100% - ${APP_BAR_HEIGHT}px)`,
            backgroundColor: (theme as any).palette.background.default,
            backgroundImage: "none",
            border: "none",
            boxShadow: "none",
            overflowX: "hidden",
            display: "flex",
            flexDirection: "column",
        },
    }
})

export { StyledRoot }
